export default {
  student: { id: 1, code: "student" },
  lecturer: { id: 2, code: "lecturer" },
  mentor: { id: 3, code: "mentor" },
};
